import { useFullTheme } from "../design";
export function useGradient(gradient) {
  var _useFullTheme = useFullTheme(),
    colors = _useFullTheme.colors;
  if (!gradient) {
    return undefined;
  }
  return {
    'magic-primary': colors.gradientMagicPrimary,
    'magic-primary-dark': colors.gradientMagicPrimaryDark,
    'negative-magic': colors.gradientNegativeMagic,
    'primary-positive': colors.gradientPrimaryPositive,
    'warning-negative': colors.gradientWarningNegative,
    positive: colors.gradientPositive,
    primary: colors.gradientPrimary
  }[gradient];
}